// extracted by mini-css-extract-plugin
export default {"pageWrap":"Qa-z","fullWidth":"Ra-z","heading":"Sa-z","fullBleed":"Ta-z","hidden":"Ua-z"};